import { useDispatch, useSelector } from 'react-redux';
import useImpression from '../../useImpression';
import { IRootState } from '../../../store';
import getFlagValue, { FLAG_ENUM } from '../../../helpers/utils/getFlagValue';
import { IBreadcrumbs } from '../../../components/molecules/Breadcrumbs';
import { addQueueCouponServiceCount } from '../../../store/emarsys/action';

const useImpressionCouponService = (
  firstRef: React.RefObject<HTMLElement>,
  pageTitle: string = '',
  breadcrumbItems: IBreadcrumbs[],
  sectionName: string = ''
) => {
  const dispatch = useDispatch();
  const { isLargeScreen } = useSelector((state: IRootState) => state.page) || {
    isLargeScreen: false,
  };
  const { isAuth, userData } = useSelector((state: IRootState) => state.auth) || {
    isAuth: false,
    userData: null,
  };
  const { selectedCar, selectedPackage } = useSelector((state: any) => state.servicePackage) || {
    selectedCar: null,
    selectedPackage: null,
  };

  useImpression(
    firstRef,
    1,
    () => {
      const isFlagActive = getFlagValue(FLAG_ENUM.EMARSYS);
      const isCouponServiceActive = getFlagValue(FLAG_ENUM.EMARSYS_COUPON_SERVICE_DETAIL);
      if (isAuth && isFlagActive && isCouponServiceActive) {
        const valuePageView: Record<string, string | number | boolean> = {
          page_name: 'kupon servis detail page',
          page_title: pageTitle,
          page_url: window.location.href,
          menu_cat_lvl1: breadcrumbItems?.[1]?.name?.toUpperCase() || '',
          menu_cat_lvl2: breadcrumbItems?.[2]?.name?.toUpperCase() || '',
          menu_cat_lvl3: breadcrumbItems?.[3]?.name?.toUpperCase() || '',
          menu_cat_lvl4: breadcrumbItems?.[4]?.name?.toUpperCase() || '',
          coupon_name: selectedPackage?.name?.toLowerCase() || '',
          sku_price: (
            selectedPackage?.strikeThroughPrice?.value ||
            selectedPackage?.price?.value ||
            0
          ).toString(),
          car_category: selectedPackage?.bodyTypeName || '',
          car_model: selectedPackage?.carModelService || '',
          car_type: selectedCar?.vehicleName || '',
          section_name: sectionName,
        };

        if (userData?.customerNo) {
          ScarabQueue.push(['setCustomerId', userData?.customerNo]);
        }
        ScarabQueue.push(['tag', 'impressions', valuePageView]);

        dispatch(addQueueCouponServiceCount());
      }
    },
    {
      rootMargin: isLargeScreen ? '-161px 0px 0px 0px' : '-106px 0px 0px 0px',
    },
    [isAuth],
    isLargeScreen ? 161 : 106,
    isLargeScreen ? 0 : 0
  );

  return null;
};

export default useImpressionCouponService;
